import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";
import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { roundDecimalValueUptoTwoDigit } from "utils/RoundDecimalValue";

export const costingUrlKey = "costing_id";

export const openCostingFabricAssocObjKey = "openCostingFabric";
export const openCostingSewingTrimsAssocObjKey = "openCostingSewingTrims";
export const openCostingPackingTrimsAssocObjKey = "openCostingPackingTrims";
export const openCostingTrimsDynamicConsumpAssocObjKey = "openCostingTrimsDynamicConsump";
export const openCostingValueAddAssocObjKey = "openCostingValueAdd";
export const openCostingOtherChargesAssocObjkey = "openCostingOtherCharges";
export const openCostingPoCostAssocObjkey = "openCostingPoCost";

export const optionDetailsReqColumns = {
	style_ref_no: { NOTNULL: true, DISPLAY: true },
	style_name: { NOTNULL: true, DISPLAY: true },
	color: { NOTNULL: true, DISPLAY: true },
	pallete: { NOTNULL: true, DISPLAY: true },
	season: { NOTNULL: true, DISPLAY: true },
	brand: { NOTNULL: true, DISPLAY: true },
	sub_brand: { NOTNULL: false, DISPLAY: true },
	division: { NOTNULL: false, DISPLAY: true },
	category: { NOTNULL: true, DISPLAY: true },
	sub_category: { NOTNULL: false, DISPLAY: true },
};

export const filterRequiredStyleColumns = (styleAllAttributesObj) => {
	return Object.keys(optionDetailsReqColumns)?.reduce((acc, col) => {
		if (styleAllAttributesObj[col]) acc.push({ ...styleAllAttributesObj[col], constraints: optionDetailsReqColumns[col] });
		return acc;
	}, []);
};

export const totalQtyColumn = {
	name: "Total Qty",
	key: "total_qty",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.NUMBER.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: 0,
};
export const supplierColumn = {
	name: "Supplier",
	key: "supplier",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: 0,
};
export const paymentTermColumn = {
	name: "Payment Term (Days)",
	key: "payment_term",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.NUMBER.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: 0,
};
export const applyDiscountingCol = {
	name: "Discounting Apply",
	key: "discounting_applied",
	input_type: inputTypes.SELECT.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.BOOLEAN.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: 0,
	[selectOptionsKeyName]: {
		type: arrType,
		list: ["YES", "NO"].map((val) => ({ name: val, key: val })),
	},
};
export const poCostColumn = {
	name: "Po Cost",
	key: "po_cost",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.DECIMAL.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: 0,
};
export const finalTotalColumn = {
	name: "Final Total",
	key: "final_total",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.DECIMAL.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: 0,
};
export const CreatedAtColumn = {
	name: "Created At",
	key: "created_at",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.DECIMAL.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: 0,
};

export const DisabledBox = ({ field, row }) => {
	return (
		<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center" sx={{ background: grey[100] }}>
			<span style={{ textTransform: "uppercase" }}>
				{typeof row[field] === "string"
					? row[field]?.split("_").join(" ")
					: typeof row[field] === "number"
					? roundDecimalValueUptoTwoDigit(row[field])
					: row[field]}
			</span>
		</Box>
	);
};
export const WhiteBgBox = ({ field, row }) => {
	return (
		<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center" sx={{ background: "white" }}>
			<span style={{ textTransform: "uppercase" }}>
				{typeof row[field] === "string"
					? row[field]?.split("_").join(" ")
					: typeof row[field] === "number"
					? roundDecimalValueUptoTwoDigit(row[field])
					: row[field]}{" "}
			</span>
		</Box>
	);
};
export const TotalBox = ({ field, row }) => {
	return (
		<Box
			width="100%"
			height="100%"
			display="flex"
			alignItems="center"
			justifyContent="center"
			sx={{ background: grey[300], fontWeight: 600 }}>
			<span style={{ textTransform: "uppercase" }}>
				{typeof row[field] === "string"
					? row[field]?.split("_").join(" ")
					: typeof row[field] === "number"
					? roundDecimalValueUptoTwoDigit(row[field])
					: row[field]}{" "}
			</span>
		</Box>
	);
};

export const removeKeyFromArrOfObj = (arr, column) => {
	return arr.reduce((acc, row) => {
		let obj = { ...row };
		if (obj[column]) delete obj[column];
		acc.push(obj);
		return acc;
	}, []);
};
